import { IFilterSet, TFilter } from 'shared/types/filters';
import { MIXED_FLAT_FILTERS_SET } from './mixedFlat';
import { BED_FILTERS_SET } from './bed';
import { ROOM_FILTERS_SET } from './room';
import { FLAT_SHARED_FILTERS_SET } from './flatShared';
import { HOTEL_FILTERS_SET } from './hotel';
import { MIXED_SUBURBAN_FILTERS_SET } from './mixedSuburban';
import { OTHER_FILTERS_SET } from './other';

export const FILTERS_SET: IFilterSet<TFilter>[] = [
  ...BED_FILTERS_SET,
  ...ROOM_FILTERS_SET,
  ...FLAT_SHARED_FILTERS_SET,
  ...HOTEL_FILTERS_SET,
  ...MIXED_FLAT_FILTERS_SET,
  ...MIXED_SUBURBAN_FILTERS_SET,
  ...OTHER_FILTERS_SET,
];
